import type { CartType, FulfillmentType } from '~/utils/types';
import {
  RESET_MENU_ITEM_CART_DATA,
  SET_MENU_ITEM_CART_BYPASS_PROMPT,
  SET_MENU_ITEM_CART_IS_SCHEDULED,
  SET_MENU_ITEM_CART_LOCATION_ID,
  SET_MENU_ITEM_CART_SCHEDULED_AT,
  SET_MENU_ITEM_CART_SPECIAL_INSTRUCTIONS_MAX_LENGTH,
  SET_MENU_ITEM_CART_TYPE,
  SET_MENU_ITEM_CART_FULFILLMENT_TYPE,
  SET_MENU_ITEM_CART_ID,
  SET_SELECTED_MENU_ITEM,
  SET_SELECTED_SECTION_INDEX,
  SET_SELECTED_SECTION_OFFSET,
  SET_SELECTED_SECTION_SLUG,
  SET_SHOULD_PRELOAD_SECTIONS,
  SET_FOCUS_FIRST_SECTION_ITEM_EFFECT,
  type MenuItemCartAction,
} from './MenuItemCartActions';

export interface MenuItemCartState {
  bypassPrompt: boolean;
  focusFirstSectionItemEffect: 'active' | 'standby'
  menuItemCartFulfillmentType: Optional<FulfillmentType>;
  menuItemCartId: Optional<number>;
  menuItemCartIsScheduled: boolean | null;
  menuItemCartLocationId: Optional<number>;
  menuItemCartScheduledAt: unknown;
  menuItemCartSpecialInstructionsMaxLength: Optional<number>;
  menuItemCartType: Optional<CartType>;
  selectedMenuItem: Optional<{
    menuId: Optional<number>;
    menuSectionId: Optional<number>;
  }>;
  selectedSectionIndex: number;
  selectedSectionOffset: number;
  selectedSectionSlug: Optional<string>;
  shouldPreloadSections: boolean;
}

const initialState: MenuItemCartState = {
  bypassPrompt: false,
  focusFirstSectionItemEffect: 'standby',
  menuItemCartFulfillmentType: null,
  menuItemCartId: null,
  menuItemCartIsScheduled: null,
  menuItemCartLocationId: null,
  menuItemCartScheduledAt: null,
  menuItemCartSpecialInstructionsMaxLength: null,
  menuItemCartType: 'default_cart_type',
  selectedMenuItem: {
    menuId: null,
    menuSectionId: null,
  },
  selectedSectionIndex: -1,
  selectedSectionOffset: 0,
  selectedSectionSlug: null,
  shouldPreloadSections: false,
};

const MenuItemCartReducer = (state: MenuItemCartState = initialState, action: MenuItemCartAction): MenuItemCartState => {
  switch (action.type) {
    case SET_MENU_ITEM_CART_BYPASS_PROMPT:
      return {
        ...state,
        bypassPrompt: action.bypassPrompt,
      };
    case SET_MENU_ITEM_CART_IS_SCHEDULED:
      return {
        ...state,
        menuItemCartIsScheduled: action.menuItemCartIsScheduled,
      };
    case SET_MENU_ITEM_CART_LOCATION_ID:
      return {
        ...state,
        menuItemCartLocationId: action.menuItemCartLocationId,
      };
    case SET_MENU_ITEM_CART_SCHEDULED_AT:
      return {
        ...state,
        menuItemCartScheduledAt: action.menuItemCartScheduledAt,
      };
    case SET_MENU_ITEM_CART_TYPE:
      return {
        ...state,
        menuItemCartType: action.menuItemCartType,
      };
    case SET_MENU_ITEM_CART_FULFILLMENT_TYPE:
      return {
        ...state,
        menuItemCartFulfillmentType: action.menuItemCartFulfillmentType,
      };
    case SET_MENU_ITEM_CART_ID:
      return {
        ...state,
        menuItemCartId: action.menuItemCartId,
      };
    case SET_MENU_ITEM_CART_SPECIAL_INSTRUCTIONS_MAX_LENGTH:
      return {
        ...state,
        menuItemCartSpecialInstructionsMaxLength: action.menuItemCartSpecialInstructionsMaxLength,
      };
    case RESET_MENU_ITEM_CART_DATA:
      return {
        ...initialState,
      };
    case SET_SELECTED_MENU_ITEM:
      return {
        ...state,
        selectedMenuItem: action.selectedMenuItem,
      };
    case SET_SELECTED_SECTION_INDEX:
      return {
        ...state,
        selectedSectionIndex: action.selectedSectionIndex,
      };
    case SET_SELECTED_SECTION_OFFSET:
      return {
        ...state,
        selectedSectionOffset: action.selectedSectionOffset,
      };
    case SET_SELECTED_SECTION_SLUG:
      return {
        ...state,
        selectedSectionSlug: action.selectedSectionSlug,
      };
    case SET_SHOULD_PRELOAD_SECTIONS:
      return {
        ...state,
        shouldPreloadSections: action.shouldPreloadSections,
      };
    case SET_FOCUS_FIRST_SECTION_ITEM_EFFECT:
      return {
        ...state,
        focusFirstSectionItemEffect: action.status,
      };
    default:
      return state;
  }
};

export default MenuItemCartReducer;
